import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import * as CustomEditor from "../../../assets/ckeditor5/ckEditor";
import { environment } from "../../../environments/environment";
import { UserService } from "../../@core/services/user.service";
import { FileStorageService } from "../../services/file-storage.service";

import { MyUploadAdapter } from "../../services/ckupload-adapter.service";

@Component({
  selector: "ngx-editor-document",
  styleUrls: ["./editor-document.component.scss"],
  templateUrl: "./editor-document.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorDocumentComponent),
      multi: true,
    },
  ],
})
export class EditorDocumentComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private destroy$: Subject<void> = new Subject<void>();
  //CKEditor5
  public Editor = CustomEditor;
  onReady(editor) {
    if (editor.model.schema.isRegistered("image")) {
      editor.model.schema.extend("image", { allowAttributes: "blockIndent" });
    }
    editor.plugins.get("FileRepository").createUploadAdapter = (
      loader: any
    ) => {
      return new MyUploadAdapter(loader, this.fileStorageService);
    };
  }

  @Input() content: string;
  @Input() readOnly: boolean = false;
  @Input() config = {
    toolbar: {
      items: [
        "undo",
        "redo",
        "|",
        "heading",
        "fontSize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "underline",
        "bulletedList",
        "numberedList",
        "|",
        "outdent",
        "indent",
        "alignment",
        "|",
        "link",
        // "imageUpload",
        "imageInsert",
        "blockQuote",
        "insertTable",
        "mediaEmbed",
        "|",
        "specialCharacters",
        "strikethrough",
        "subscript",
        "superscript",
        "|",
        "pageBreak",
        "codeBlock",
        "highlight",
        "fontFamily",
      ],
      shouldNotGroupWhenFull: false,
      viewportTopOffset: 30,
    },
    image: {
      // Configure the available styles.
      styles: ["alignLeft", "alignCenter", "alignRight"],

      // Configure the available image resize options.
      resizeOptions: [
        {
          name: "resizeImage:original",
          label: "Original",
          value: null,
        },
        {
          name: "resizeImage:50",
          label: "25%",
          value: "25",
        },
        {
          name: "resizeImage:50",
          label: "50%",
          value: "50",
        },
        {
          name: "resizeImage:75",
          label: "75%",
          value: "75",
        },
      ],

      // You need to configure the image toolbar, too, so it shows the new style
      // buttons as well as the resize buttons.
      toolbar: [
        "imageTextAlternative",
        "imageStyle:inline",
        "imageStyle:block",
        "imageStyle:side",
        "linkImage",
      ],
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties",
      ],
    },
    // simpleUpload: {
    //   // The URL that the images are uploaded to.
    //   // uploadUrl: environment.apiUrl + "/FileStorage/CKEditor",

    //   // Enable the XMLHttpRequest.withCredentials property.
    //   // withCredentials: true,
    //   // headers: {
    //   //   "X-CSRF-TOKEN": "CSRF-Token",
    //   //   Authorization: "Bearer <JSON Web Token>",
    //   // },

    // },

    language: "vi",
  };

  uid = "";

  private _value: string = "";

  get value() {
    return this._value;
  }

  set value(v: string) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  constructor(
    public userService: UserService,
    private fileStorageService: FileStorageService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          // this.config.simpleUpload.headers.Authorization =
          //   "Bearer " + this.userService.getToken();
          // this.getImageKitToken();
        } else {
          this.uid = "";
          // this.config.simpleUpload.headers.Authorization = "Bearer ";
        }
      });

    console.log("EditorDocumentComponent/config:", this.config);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onChange(_) {}
  onTouch() {}

  writeValue(obj: any): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }
}
